import { SizeClassNames, CHECKBOX_SIZE } from "./types";

export const SIZE_CLASS_MAP: Record<CHECKBOX_SIZE, SizeClassNames> = {
  [CHECKBOX_SIZE.LARGE]: {
    inputClassName: "h-5 w-5",
    labelClassName: "body-md",
  },
  [CHECKBOX_SIZE.MEDIUM]: {
    inputClassName: "h-4 w-4",
    labelClassName: "body-sm",
  },
  [CHECKBOX_SIZE.SMALL]: {
    inputClassName: "h-3.5 w-3.5",
    labelClassName: "body-xsm",
  },
};
